document.addEventListener('DOMContentLoaded', function () {
	updateSectionDescription();
	const zoomImages = document.querySelectorAll('.product-media-modal__content .modal-image-wrapper');
	zoomImages.forEach(parent => {
		const image = parent.querySelector('img');
		const mediaTitle = image.getAttribute('alt').split(' || ')[0];

		const variantTitle = document
			.querySelector('.product-section__variant-thumbnail.is-active')
			.getAttribute('data-variant-title');
		let variantLensTitle;
		if (document.querySelector('.product-section__variant-thumbnail.lens.is-active')) {
			variantLensTitle = document
				.querySelector('.product-section__variant-thumbnail.lens.is-active')
				.getAttribute('data-variant-option');
		}
		
		if(mediaTitle ===  variantTitle) {
			parent.style.display = 'block';
		} else {
			parent.style.display = 'none';
		}
	})

  document.querySelectorAll('li.product__media-item.grid__item.slider__slide').forEach((media, index) => {
    const mediaTitle = media.getAttribute('data-variant-media-alt').split(' || ')[0];
    const variantTitle = document
      .querySelector('.product-section__variant-thumbnail.is-active')
      .getAttribute('data-variant-title');
    let variantLensTitle;
    if (document.querySelector('.product-section__variant-thumbnail.lens.is-active')) {
      variantLensTitle = document
        .querySelector('.product-section__variant-thumbnail.lens.is-active')
        .getAttribute('data-variant-option');
    }

    if (mediaTitle === 'E-GIFT CARD') return;
		
    if (mediaTitle && mediaTitle === variantTitle) {
      media.style.display = 'block';
    } else {
      media.style.display = 'none';
    }
  });

  const customeShippingSection = document.querySelector('.custom_shipping_details');
	if (customeShippingSection.dataset.country !== 'united_states') {
		if(customeShippingSection.querySelector('.data.mobile')) customeShippingSection.querySelector('.data.mobile')?.classList.add('hidden');
		if(customeShippingSection.querySelector('.data_international.mobile')) customeShippingSection.querySelector('.data_international.mobile').classList.remove('hidden');
		if(customeShippingSection.querySelector('.data.desktop')) customeShippingSection.querySelector('.data.desktop').classList.add('hidden');
		if(customeShippingSection.querySelector('.data_international.desktop')) customeShippingSection.querySelector('.data_international.desktop').classList.remove('hidden');
	}



  let hasRxLink = false;
  var rxLink = '#';
  const customShippingDetails = document.querySelector('.custom_shipping_details');

  document.querySelectorAll('.product-section__variant-thumbnail.is-active').forEach(function (thumbnail) {
    var filterAlt = thumbnail.dataset.filter;
    if (thumbnail.dataset.prescriptionBtn) {
      rxLink = thumbnail.dataset.prescriptionBtn;
    }
    var rxImage = thumbnail.dataset.rxImage;
    const rxImageTag = document.querySelector('.link-to-rx .rx-image');
    const linkToRx = document.querySelector('.link-to-rx');

    if (rxLink) hasRxLink = true;
    if (customShippingDetails && rxLink) customShippingDetails.style.borderTop = '1px solid #DFDFDF';
    if (!hasRxLink) document.querySelector('.prescription-links').style.display = 'none';

    document
      .querySelectorAll('.product-section__media-single[data-filter="' + filterAlt + '"]')
      .forEach((el) => (el.style.display = 'block'));

    if (rxImageTag && rxImage) rxImageTag.src = rxImage;
    if (linkToRx) {
      linkToRx.classList.toggle('link-to-rx_visible', !!hasRxLink);
      if (rxLink) {
      }
      linkToRx.setAttribute('href', rxLink || '#');
    }
  });

  document
    .querySelectorAll('.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail')
    .forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
				if(this.parentNode.classList.contains('original-color')) {
					const selectedSeasonalColor = document.querySelector('#selected-seasonal-color');
					if(selectedSeasonalColor) selectedSeasonalColor.textContent = "";
				}
        document
          .querySelectorAll('.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail')
          .forEach((el) => {
            if (el) el.classList.remove('is-active');
          });



        document
          .querySelectorAll('.product-section__variant-thumbnails.seasonal-color .product-section__variant-thumbnail')
          .forEach((el) => el.classList.remove('is-active'));

        this.classList.add('is-active');

        const filterAlt = this.dataset.filter;
        const filterId = this.dataset.variantId;
        const rxLink = this.dataset.prescriptionBtn;
        const rxImage = this.dataset.rxImage;
        const rxImageTag = document.querySelector('.link-to-rx .rx-image');
        const linkToRx = document.querySelector('.link-to-rx');

        document.querySelectorAll('.product-section__media-single').forEach((el) => (el.style.display = 'none'));
        document
          .querySelectorAll('.product-section__media-single[data-filter="' + filterAlt + '"]')
          .forEach((el) => (el.style.display = 'block'));

        document.querySelectorAll('.product_suspendisse').forEach((el) => (el.style.display = 'none'));
        document.querySelectorAll('.product_suspendisse_' + filterId).forEach((el) => (el.style.display = 'block'));

        if (linkToRx) {
          linkToRx.classList.toggle('link-to-rx_visible', !!rxLink);
          linkToRx.setAttribute('href', rxLink || '#');
        }
        if (rxImageTag) rxImageTag.src = rxImage;

        if (window.innerWidth < 768 && document.querySelector('.product-section__desktop-media')) {
          document.querySelector('.product-section__desktop-media').scrollTo(0, 0);
        }

        updateSelectedColor(this);
      });
    });

  document
    .querySelectorAll('.product-section__variant-thumbnails.lens-color .product-section__variant-thumbnail')
    .forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        document
          .querySelectorAll('.product-section__variant-thumbnails.lens-color .product-section__variant-thumbnail')
          .forEach((el) => {
            if (el) el.classList.remove('is-active');
          });
        this.classList.add('is-active');

        updateSelectedLensColor(this);
      });
    });

    document
        .querySelectorAll('.product-section__variant-thumbnails.seasonal-color .product-section__variant-thumbnail')
        .forEach(function (thumbnail) {
            thumbnail.addEventListener('click', function () {
                document
                    .querySelectorAll('.product-section__variant-thumbnails.seasonal-color .product-section__variant-thumbnail')
                    .forEach((el) => el.classList.remove('is-active'));
                this.classList.add('is-active');

                document
                    .querySelectorAll('.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail')
                    .forEach((el) => el.classList.remove('is-active'));

                updateSelectedSeasonalColor(this);

                // Додаємо логіку з original-color:
                const variantId = this.dataset.variantId;
                const variantAvailable = this.dataset.variantAvailable;

                updateVariantInURL(variantId);
                changeActiveVariant(variantAvailable);

                function changeActiveVariant(variant) {
                    const bool = variant === "true";
                    if (bool) {
                        document.querySelector('.product .custom_button.sold_out')?.classList.add('hide');
                        document.querySelector('.product .custom_button.add_to_cart')?.classList.remove('hide');
                    } else {
                        document.querySelector('.product .custom_button.sold_out')?.classList.remove('hide');
                        document.querySelector('.product .custom_button.add_to_cart')?.classList.add('hide');
                    }
                }

                function updateVariantInURL(variantId) {
                    const url = new URL(window.location.href);
                    url.searchParams.set('variant', variantId);
                    window.history.replaceState({}, '', url);

                    const nameId = document.querySelector('.product__info-wrapper [name="id"]');
                    nameId.value = +variantId;
                }
            });
        });

    document
    .querySelectorAll('.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail')
    .forEach((element) => {
      element.addEventListener('click', function () {
        const variantId = this.dataset.variantId;

        const variantAvailable = this.dataset.variantAvailable;


        updateVariantInURL(variantId);
        updateSelectedColor(this);
        changeActiveVariant(variantAvailable);
				pdpPriceInsert(element);
				
				function pdpPriceInsert(element) {
					const compare = element.dataset.compare || null;
					const pdpCompareVariantPrice = document.querySelector('.product .price');

					if(!element) return;
					if(!compare) {
						pdpCompareVariantPrice.classList.remove('price--on-sale');
						const pdpVariantPrice = document.querySelector('.product .price__regular .price-item');
						const variantPrice = element.dataset.pdpVariantPrice;
						pdpVariantPrice.textContent = variantPrice;
					} else {
						const compareVariantPrice = element.dataset.variantCompare;
						const compareVariantPriceBox = document.querySelector('.product .price s.price-item.price-item--regular');
						compareVariantPriceBox.textContent = compareVariantPrice;
						pdpCompareVariantPrice.classList.add('price--on-sale');
					}
				}

        function changeActiveVariant(variant) {
          const str = variant; // або "false"
          const bool = variant === "true";


          if(bool) {
            document.querySelector('.product .custom_button.sold_out')?.classList.add('hide');
            document.querySelector('.product .custom_button.add_to_cart')?.classList.remove('hide');
          } else {
            document.querySelector('.product .custom_button.sold_out')?.classList.remove('hide');
            document.querySelector('.product .custom_button.add_to_cart')?.classList.add('hide');
          }
        }

        function updateVariantInURL(variantId) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url);

          const nameId = document.querySelector('.product__info-wrapper [name="id"]');
          nameId.value = +variantId;
        }
      });
    });

  document
    .querySelectorAll('.product-section__variant-thumbnails.lens-color .product-section__variant-thumbnail')
    .forEach((element) => {
      element.addEventListener('click', function () {
        updateSelectedLensColor(this);
      });
    });

  document
    .querySelectorAll('.product-section__variant-thumbnails.seasonal-color .product-section__variant-thumbnail')
    .forEach((element) => {
      element.addEventListener('click', function () {
        updateSelectedSeasonalColor(this);
      });
    });

  function updateSelectedColor(element) {
    document.querySelector('.variation-name #selected-color').textContent = element.getAttribute('data-variant-option');
    updatePDP(element);
  }

  function updateSelectedLensColor(element) {
    document.querySelector('.variation-name #selected-lens-color').textContent =
      element.getAttribute('data-variant-option');

    document.querySelectorAll('.original-color .product-section__variant-thumbnail').forEach((original) => {
      if (original.getAttribute('data-filter').includes(element.getAttribute('data-filter'))) {
        original.classList.remove('hide-color');
      } else {
        original.classList.add('hide-color');
      }
    });

    updatePDP(element);
  }

  function updateSelectedSeasonalColor(element) {

			if(element.parentNode.classList.contains('seasonal-color')) {
				document.querySelector('.variation-name #selected-color').textContent = "";
				document.querySelector('#selected-seasonal-color').textContent = element.getAttribute('data-variant-option1');
			} else {
				document.querySelector('.variation-name #selected-color').textContent = element.getAttribute('data-variant-option1');
			}

			const newVariantId = element.dataset.variantId;
			const url = new URL(window.location.href);
			url.searchParams.set('variant', newVariantId);
			history.replaceState(null, '', url.toString());

    updatePDP(element);
  }
		function updateSectionDescription() {
			const sections = document.querySelectorAll('.product-description__section');
			sections.forEach((section) => {
				const sectionVariantId = section.getAttribute('data-variant-id');
				if (
					+sectionVariantId ===
					+document.querySelector('.product-section__variant-thumbnail.is-active').getAttribute('data-variant-id')
				) {
					section.classList.remove('hide');
				} else {
					section.classList.add('hide');
				}
			});
		}
  function updatePDP(element) {
    let variantTitle = element.getAttribute('data-variant-title');
		updateSectionDescription()
		
    if (element.classList.contains('lens')) {
      variantTitle = element.getAttribute('data-variant-option');
    }
    const newVariantId = element.getAttribute('data-variant-id');
    const productType = element.getAttribute('data-product-type');
    const isAvailable = element.getAttribute('data-variant-available') === 'true';
    document.querySelectorAll('.product .product-variant-id').forEach((element) => (element.value = newVariantId));
    let count = 0;

    document.querySelectorAll('li.product__media-item.grid__item.slider__slide').forEach((media) => {
			const seasonalColor = document.querySelectorAll('#selected-seasonal-color');
      const mediaTitle = media.getAttribute('data-variant-media-alt');

      if (mediaTitle === 'E-GIFT CARD') return;
			if(seasonalColor.length > 0) {
				if (mediaTitle && variantTitle === mediaTitle.split(' || ')[0]) {
					if (count === 0) {
						media.style.position = 'relative';
						media.querySelector('svg').style.display = 'block';
					}
					media.style.display = 'block';
					count++;
				} else {
					media.style.display = 'none';
				}
			}

			else {
				let oldVariant = document.querySelector('.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail.is-active.hide-color');
				const newVariants = document.querySelectorAll('.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail');
				const productMediaList = document.querySelectorAll('.product__media-list li');
				let lensColors = document.querySelector('.product-section__variant-thumbnails.lens-color .product-section__variant-thumbnail.lens.is-active');

				if(!oldVariant) {
					oldVariant = document.querySelector('.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail.is-active');
				}

				newVariants.forEach(newVariant => {
					if(!newVariant.classList.contains('hide-color') && newVariant.dataset.variantOption === oldVariant.dataset.variantOption) {

						if(oldVariant.classList.contains('hide-color')) {
							newVariant.click();
						}

						if(!productMediaList.length > 0 || !lensColors) {
							lensColors = document.querySelector('.product-section__variant-thumbnails .product-section__variant-thumbnail.is-active');
						}

						productMediaList.forEach((newMedia) => {
							const newMediaAlt = newMedia.dataset.variantMediaAlt.split(' || ')[0];
							if(newMediaAlt === lensColors.dataset.variantOption) {
								newMedia.style.display = 'block';
							} else {
								newMedia.style.display = 'none';
							}
						})

					}
				})

				updateSectionDescription();
			}
    });

    document.querySelectorAll('.product-media-modal__content .modal-image-wrapper').forEach((media) => {
      const mediaTitle = media.querySelector('img').getAttribute('alt').split(' || ')[0];

      if (
        mediaTitle &&
        mediaTitle === variantTitle
      ) {
        media.style.display = 'block';
      } else {
        media.style.display = 'none';
      }
    });

    document.querySelectorAll('.slider-circle-button').forEach((button) => {
      if (button.getAttribute('data-count') > count) {
        button.style.display = 'none';
      } else {
        button.style.display = 'block';
      }
    });

    const sliderComponentPDP = document.querySelector('slider-component');
     if (sliderComponentPDP?.setSlidePosition) {
       sliderComponentPDP.setSlidePosition(0);
     }
		const parentBlock = document.querySelector('cart-drawer');
		if(!parentBlock) return;

    const buyButtons = document.querySelectorAll('.product .custom_button.add_to_cart');
    const soldoutButtons = document.querySelectorAll('.product .custom_button.sold_out');
    const selectLensesButton = document.querySelectorAll('.product .button_box .select-lenses');
    const generalButtonsWrapper = document.querySelectorAll('.product .button_box .general-buy-btns');

    if (productType?.toLowerCase().includes('prescription') && !isAvailable) {

      selectLensesButton.forEach((element) => element.classList.add('hide'));
      generalButtonsWrapper.forEach((element) => element.classList.remove('hide'));
      buyButtons.forEach((element) => element.classList.add('hide'));
      soldoutButtons.forEach((element) => element.classList.remove('hide'));
      soldoutButtons.forEach((element) => {
        element.querySelector('span').style.display = 'unset';
        element.querySelector('span').classList.remove('hide');
      });
    } else if (productType?.toLowerCase().includes('prescription') && isAvailable) {
      selectLensesButton.forEach((element) => element.classList.remove('hide'));
      generalButtonsWrapper.forEach((element) => element.classList.add('hide'));
      soldoutButtons.forEach((element) => {
				element.classList.add('hide');
			});
      buyButtons.forEach((element) => element.classList.add('hide'));
    } else if (!isAvailable) {
      buyButtons.forEach((element) => element.classList.add('hide'));
      soldoutButtons.forEach((element) => element.classList.remove('hide'));
      soldoutButtons.forEach((element) => {
        element.querySelector('span').style.display = 'unset';
        element.querySelector('span').classList.remove('hide');
      });
    } else {
      buyButtons.forEach((element) => element.classList.remove('hide'));
      soldoutButtons.forEach((element) => element.classList.add('hide'));
    }
  }

  document.querySelectorAll('.product__accordion.accordion details summary').forEach((summary) => {
    summary.addEventListener('click', toggleAccordion);
  });

  function toggleAccordion(event) {
    event.preventDefault();

    document.querySelectorAll('.product__accordion details').forEach((el) => {
      if (el !== event.currentTarget.parentElement) {
        el.removeAttribute('open');
      }
    });

    event.currentTarget.parentElement.toggleAttribute('open');
  }

	const productSectionVariantThumbnail = document.querySelectorAll('.product__info-wrapper .product-section__variant-thumbnails.original-color .product-section__variant-thumbnail');
	const anotherOptions = document.querySelectorAll('.product__info-wrapper .product-section__variant-thumbnails:not(.original-color) .product-section__variant-thumbnail');
	const params = new URLSearchParams(window.location.search);
	const urlVariantId = params.get('variant');

	productSectionVariantThumbnail.forEach(variant => {
		if(variant.dataset.variantId === urlVariantId) {
			anotherOptions.forEach(anotherOption => {
				if(variant.dataset.variantTitle.includes(anotherOption.dataset.variantOption)) {

					anotherOption.click();
				}
			})
		}
	})

	const current_active_option = document.querySelector('.product__info-wrapper .product-section__variant-thumbnails .product-section__variant-thumbnail.is-active');
	if(current_active_option && current_active_option.parentNode.classList.contains('seasonal-color')) {
		document.querySelector('#selected-color').textContent = "";
	} else {
		document.querySelector('#selected-seasonal-color').textContent = "";
	}

});

fetch('/browsing_context_suggestions.json')
  .then(res => res.json())
  .then(data => {
    const country = data.detected_values.country.handle?.toLowerCase();
    console.log('country', country);
    console.log('data detected', data);

    // shipping text
    const domestic = document.querySelector('.shipping_text');
    const international = document.querySelector('.shipping_text_international');

    // tooltips
    const tooltip = document.querySelector('.tooltiptext.tooltip');
    const tooltipInternational = document.querySelector('.tooltiptext.tooltip_international');

    // free returns
    const freeReturns = document.querySelector('.free_returns');
    const freeReturnsInternational = document.querySelector('.free_returns_international');

    if (country === 'us') {
      // shipping text
      domestic.classList.remove('hidden');
      international.classList.add('hidden');

      // tooltip
      tooltip.classList.remove('hidden');
      tooltipInternational.classList.add('hidden');

      // free returns
      freeReturns.classList.remove('hidden');
      freeReturnsInternational.classList.add('hidden');
    } else {
      // shipping text
      domestic.classList.add('hidden');
      international.classList.remove('hidden');

      // tooltip
      tooltip?.classList.add('hidden');
      tooltipInternational?.classList.remove('hidden');

      // free returns
      freeReturns.classList.add('hidden');
      freeReturnsInternational.classList.remove('hidden');
    }
  })
  .catch(error => {
    console.error('Error fetching country info:', error);
  });

document.addEventListener('DOMContentLoaded', () => {
	const originalItem = document.querySelector('.product-section__variant-thumbnails.original-color');
	const lensItems = document.querySelector('.product-section__variant-thumbnails.lens-color');

	if(originalItem && lensItems) {
		function onUrlChange(callback) {
			let oldHref = location.href;

			window.addEventListener("popstate", () => {
				if (location.href !== oldHref) {
					callback(location.href);
					oldHref = location.href;
				}
			});

			["pushState", "replaceState"].forEach(method => {
				const original = history[method];
				history[method] = function (...args) {
					original.apply(this, args);
					if (location.href !== oldHref) {
						callback(location.href);
						oldHref = location.href;
					}
				};
			});
		}

		onUrlChange(newUrl => readProduct(newUrl));

		function readProduct() {
			const params = new URLSearchParams(window.location.search);
			const currentVariantId = +params.get("variant");
			const product = JSON.parse(document.getElementById('product-data').textContent);

			if(!product) return;

			if(currentVariantId === 0) {
				const url = new URL(window.location);
				url.searchParams.set('variant', `${product.variants[0].id}`);
				window.history.replaceState({}, '', url);

				setTimeout(() => {
					readProduct();
				}, 0)
			}

			const variants = product.variants;
			const currentVariant = variants.find(variant => variant.id === currentVariantId);
			
			const originColors = document.querySelectorAll('.product__info-wrapper .product-section__variant-thumbnails.original-color .product-section__variant-thumbnail');
			const lensColor = document.querySelector(".product__info-wrapper .product-section__variant-thumbnails.lens-color")
			const productMedias = document.querySelectorAll('.product media-gallery .product__media-list .product__media-item');
			const zoomProductMedias = document.querySelectorAll('.product-media-modal__content .modal-image-wrapper');
			const descriptions = document.querySelectorAll('.product-description__section');

			setTimeout(() => {
				originColors.forEach(color => color.classList.add('hide-color'));
				productMedias.forEach(media => media.style.display = 'none');
				zoomProductMedias.forEach(media => media.style.display = 'none');

				const activeOriginColors = Array.from(originColors).filter(color => {
					const lensOption = color.dataset.variantTitle.split(' / ')[1];
					return lensOption.includes(currentVariant.options[1])
				});

				activeOriginColors.forEach(color => color.classList.remove('hide-color'));

				productMedias.forEach((media, index) => {
					const variantTitle = media.dataset.variantMediaAlt.split(' || ')[0];
					if(variantTitle === `${currentVariant.options[0]} / ${currentVariant.options[1]}`) {
						media.style.display = 'block';
					}
				})

				zoomProductMedias.forEach(media => {
					const mediaImage = media.querySelector('img');
					const mediaAlt = mediaImage.getAttribute('alt').split(' || ')[0];

					if(currentVariant.title === mediaAlt) {
						media.style.display = 'block';
					}

				})

				changeSectionDescription()
			}, 0)

			function changeSectionDescription() {
				if(descriptions.length > 0) {
					descriptions.forEach(item => item.classList.add('hide'));
					const currentDescription = Array.from(descriptions).find(item => +item.dataset.variantId === currentVariant.id);
					currentDescription.classList.remove('hide');
				}

			}
		}

		readProduct();
	}
})


	setTimeout(() => loadDots(), 0)

	const loadDots = () => {
	setTimeout(() => {
		const dots = document.querySelectorAll('.slider-circle-button');
		const images = document.querySelectorAll('.product__media-list .product__media-item');
		const images_showed = Array.from(images).filter(image => image.style.display === 'block')
		images_showed.forEach((item, index) => dots[index].style.display = 'block');
	}, 0)

	}

function handleUrlChange() {
	loadDots();
}

// реагує на назад/вперед
window.addEventListener("popstate", handleUrlChange);

// реагує на зміну hash (#)
window.addEventListener("hashchange", handleUrlChange);

// перехоплюємо pushState та replaceState
(function(history) {
	const pushState = history.pushState;
	const replaceState = history.replaceState;

	history.pushState = function (...args) {
		const result = pushState.apply(this, args);
		handleUrlChange();
		return result;
	};

	history.replaceState = function (...args) {
		const result = replaceState.apply(this, args);
		handleUrlChange();
		return result;
	};
})(window.history);


